import React from 'react';
import { eventTypes, useForm } from 'new/elements/Form/useForm';
import UserConfirmation from 'js/components/route_utils/UserConfirmation';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCurrentProjectId } from 'js/reducers/app/selectors';
import { redirectToProjectIfNeeded } from 'new/utils/projectAssignment';
import useAppDispatch from 'js/hooks/useAppDispatch';

interface FormLeaveConfirmationProps {
  /**
   * @returns true if the behavior is going to be overridden, false if it should not be overridden
   */
  onDismiss: () => boolean | void;
}

const message =
  'Are you sure you want to exit this editor?  All of your current changes will be discarded. ';
export const FormLeaveConfirmation = (props: FormLeaveConfirmationProps) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const currentProjectId = useSelector(getCurrentProjectId);
  const { showLeaveConfirmation, setShowLeaveConfirmation, sendEvent } = useForm();

  const onConfirmLeave = () => {
    const shouldOverride = props.onDismiss?.();
    sendEvent(eventTypes.DISMISS);
    if (shouldOverride) {
      // Close the confirmation modal if the behavior is overridden
      setShowLeaveConfirmation(false);
      return;
    }
    /**
     * Navigate to the return path if it exists,
     * otherwise redirect to the project if user started flow creation from a project context,
     * otherwise go back if there is history,
     * otherwise redirect to the homepage.
     */

    const returnPath = (history.location.state as any)?.returnPath;

    if (returnPath) {
      history.replace(returnPath);
    } else if (currentProjectId) {
      redirectToProjectIfNeeded(history, currentProjectId, dispatch);
    } else if (history.length > 2) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  const onCancel = () => {
    setShowLeaveConfirmation(false);
  };

  if (!showLeaveConfirmation) return null;

  return <UserConfirmation message={message} onCancel={onCancel} onConfirm={onConfirmLeave} />;
};
